import Button from './custom-btn';
import React from 'react';

const ConfirmationModal = ({ confirmAction, setIsConfirmModalOpen, handleConfirm, loading, errorMessage,label }) => {
    return (
        <div className="space-y-4">
            <p className="xs:text-lg text-center font-semibold">
                Are you sure you want to {confirmAction} this {label || 'entry'}?
            </p>
            {errorMessage && (
                <p className="text-red-600 text-sm text-center">{errorMessage}</p>
            )}
            <div className="flex gap-4 w-full pt-4">
                <Button
                    onClick={() => setIsConfirmModalOpen(false)}
                    className="px-4 py-2 !w-full border rounded-md"
                    label="Cancel"
                    buttonParent="w-full"
                    disabled={loading}
                />
                <Button
                    onClick={handleConfirm}
                    className={`px-4 py-2 !w-full rounded-md ${confirmAction === 'delete' ? 'bg-red-600' : 'bg-btnBg'} text-white`}
                    label={confirmAction === 'delete' ? 'Delete' : 'Confirm'}
                    loading={loading}
                    disabled={loading}
                    loadingLabel={confirmAction === 'delete' ? 'Deleting...' : 'Confirming...'}
                    buttonParent="w-full"
                />
            </div>
        </div>
    );
};

export default ConfirmationModal;